import * as React from 'react';
import Spaces from './spaces';
import Feed from './feed';
import Ask from './ask';
import Refuel from './refuel';
import { makeStyles } from '@material-ui/core';

const Sidebar = (props: any) => {
	const useStyles = makeStyles(theme => ({
		sideBarList: {
			paddingTop: '0px !important',
			paddingBottom: '0px !important',
			marginBottom: '6px !important',
			disableRipple: true,
			'& .Mui-selected': {
				backgroundColor: '#007DBA',
				border: '2px #007DBA !important',
				'& .MuiTypography-body1': {
					color: '#FFFFFF',
					font: 'normal normal normal 16px/12px Roboto',
					'@media(max-width:1024px)': {
						font: 'normal normal normal 10px/6px Roboto',
					},
				},

				'& > * svg': {
					color: '#FFFFFF',
					width: '18px',
					height: '18px',
					opacity: '1',
					letterSpacing: '0px',
					textAlign: 'left',
					font: 'normal normal 300 18px/12px Font Awesome 5 Pro',
					'@media(max-width:1024px)': {
						width: '12px',
						height: '12px',
						verticalAlign: '0.25em',
					},
				},
			},
			'& .Mui-selected:focus-visible': {
				border: '2px solid #002855 !important',
				backgroundColor: '#007DBA !important',
			},
			'& .Mui-selected:hover': {
				backgroundColor: '#002855 !important',
				width: '228px',
				border: '2px #002855 !important',
				padding: '-4px !important',
				opacity: 1,

				'@media(max-width:1024px)': {
					width: '90%',
				},
				'& .MuiTypography-body1': {
					color: '#FFFFFF!important',
					opacity: 1,
				},
				'& > * svg': {
					color: '#FFFFFF!important',
					opacity: 1,
				},
			},
			'& .MuiTypography-body1': {
				fontWeight: theme.typography.fontWeightMedium,
			},

			'& > * svg': {
				color: '#007dba',
				width: '18px',
				height: '18px',
				letterSpacing: '0px',
				textAlign: 'left',
				font: 'normal normal 300 18px/12px Font Awesome 5 Pro',
				opacity: 1,
				'@media(max-width:1024px)': {
					width: '12px',
					height: '12px',
				},
			},
			'& .MuiListItemText-primary': {
				width: '35px',
				height: '19px',
				color: '#007dba',
				font: 'normal normal normal 16px/12px Roboto',
				letterSpacing: '0px',
				textAlign: 'left',
				opacity: 1,
				'@media(max-width:1024px)': {
					font: 'normal normal normal 10px/6px Roboto',
				},
			},
			'& .MuiListItemText-primary:hover': {
				color: '#007DBA',
				width: '35px',
				height: '19px',
				textAlign: 'left',
				letterSpacing: '0px',
				opacity: 1,
			},
			'& .MuiListItem-button': {
				width: '228px',
				height: '40px',
				borderRadius: '4px',
				margin: 'auto',
				font: 'normal normal normal 16px/12px Roboto',
				opacity: 1,
				border: '2px solid transparent',

				'@media(max-width:1024px)': {
					font: 'normal normal normal 10px/6px Roboto',
					width: '90%',
					height: '30px',
				},
			},
			'& .MuiListItemText-root': {
				marginTop: '0px !important',
				marginBottom: '0px !important',
				color: '#FFFFFF',
			},
			'& .MuiListItem-button:focus-visible': { border: '2px solid #002855 !important', backgroundColor: '#FFFFFF' },
			'& .MuiListItem-button:hover': {
				'& > * svg': {
					color: '#FFFFFF',
					opacity: 1,
					height: '18px',
					letterSpacing: '0px',
					textAlign: 'left',
					'@media(max-width:1024px)': {
						height: '12px',
					},
				},

				backgroundColor: '#007DBA',
				borderRadius: '4px',

				border: '2px solid #007DBA',
				opacity: 1,
				'& .MuiListItemText-primary': {
					color: '#FFFFFF',
					width: '35px',
					height: '19px',
					font: 'normal normal normal 16px/12px Roboto',
					letterSpacing: '0px',
					textAlign: 'left',
					opacity: 1,
					'@media(max-width:1024px)': {
						font: 'normal normal normal 10px/6px Roboto',
					},
				},
			},
		},
		miniSideBarList: {
			paddingTop: '0px !important',
			paddingBottom: '0px !important',
			marginBottom: '6px !important',
			disableRipple: true,

			'& .Mui-selected': {
				backgroundColor: '#007DBA',
				'& .MuiTypography-body1': {
					color: '#FFFFFF',
					font: 'normal normal normal 16px/12px Roboto',
				},
				'& > * svg': {
					color: '#FFFFFF',
					width: '18px !important',
					height: '18px',
					opacity: '1',
					letterSpacing: '0px',
					textAlign: 'left',
					font: 'normal normal 300 18px/12px Font Awesome 5 Pro',
					'@media(max-width:1024px)': {
						width: '18px !important',
						height: '18px',
					},
				},
			},
			'& .Mui-selected:hover': {
				backgroundColor: '#007DBA !important',
				borderColor: '#007DBA !important',
				padding: '-4px !important',
				opacity: 1,
				'& .MuiTypography-body1': {
					font: 'normal normal normal 16px/12px Roboto',
					color: '#FFFFFF!important',
					opacity: 1,
				},
				'& > * svg': {
					color: '#FFFFFF!important',
					opacity: 1,
				},
			},
			'& .MuiTypography-body1': {
				fontWeight: theme.typography.fontWeightMedium,
			},

			'& > * svg': {
				color: '#007dba',
				width: '18px !important',
				height: '18px !important',
				letterSpacing: '0px',
				textAlign: 'left',
				font: 'normal normal 300 18px/12px Font Awesome 5 Pro',
				opacity: 1,
			},
			'& .MuiListItemText-primary': {
				width: '35px',
				height: '19px',
				color: '#14A0D6',
				font: 'normal normal normal 16px/12px Roboto',
				letterSpacing: '0px',
				textAlign: 'left',
				opacity: 1,
			},
			'& .MuiListItemText-primary:hover': {
				color: '#007DBA',
				width: '35px',
				height: '19px',
				font: 'normal normal normal 16px/12px Roboto',
				textAlign: 'left',
				letterSpacing: '0px',
				opacity: 1,
			},
			'& .MuiListItem-button': {
				width: '42px',
				height: '40px',
				borderRadius: '4px',
				font: 'normal normal normal 16px/12px Roboto',
				opacity: 1,
				paddingLeft: '10px',
				border: '2px solid transparent',
			},
			'& .MuiListItemText-root': {
				marginTop: '0px !important',
				marginBottom: '0px !important',
				color: '#FFFFFF',
			},
			'& .MuiListItem-button:hover': {
				'& > * svg': {
					color: '#007DBA',
					opacity: 1,
					height: '18px',
					letterSpacing: '0px',
					textAlign: 'left',
					font: 'normal normal 300 18px/12px Font Awesome 5 Pro',
					'@media(max-width:1024px)': {
						width: '18px !important',
						height: '18px',
					},
				},
				borderRadius: '4px',
				backgroundColor: '#FFFFFF',
				border: '2px solid #007DBA',
				opacity: 1,
				'& .MuiListItemText-primary': {
					color: '#007DBA',
					width: '35px',
					height: '19px',
					font: 'normal normal normal 16px/12px Roboto',
					letterSpacing: '0px',
					textAlign: 'left',
					opacity: 1,
				},
			},
		},
		listIcon: {
			minWidth: 'auto',
			width: '32px',

			'@media(max-width:1024px)': {
				width: '18px',
				'& svg': {
					width: props.drawerOpen ? '11.2px !important' : '18px !important',
					height: props.drawerOpen ? '11.2px' : '18px',
				},
			},
		},
		listCollapse: {
			'& .MuiListItemText-root': {
				paddingLeft: theme.spacing(2),
			},
		},
		listCollapseSelected: {
			'& .MuiListItemText-root': {
				paddingLeft: theme.spacing(0),
			},
		},
		listCollapseIcon: {
			display: 'flex',
		},
		menuList: {},
		listIconMargin: {
			marginRight: '15px',
		},
		sideScrollBar: {
			height: 'calc(100vh - 128px)',
			overflowY: 'auto',
			overflowX: 'hidden',
		},
	}));
	const classes = useStyles();
	const menuItems: any[] = [
		{ name: 'feed', component: <Feed classNames={classes} drawerOpen={props.drawerOpen} /> },
		{ name: 'ask', component: <Ask classNames={classes} drawerOpen={props.drawerOpen} /> },
		{ name: 'refuel', component: <Refuel classNames={classes} drawerOpen={props.drawerOpen} /> },
		{ name: 'spaces', component: <Spaces classNames={classes} drawerOpen={props.drawerOpen} /> },
	];

	const handleSideBarKeyDown = (name: string) => {
		if (name === 'ask') {
			setTimeout(() => {
				document.getElementById('askLandingPage')?.focus();
			}, 500);
		}
	};

	return (
		<div className={classes.sideScrollBar}>
			{menuItems.map((item: any, index: any) => (
				<div
					key={index}
					className={classes.menuList}
					onKeyDown={e => e.key === 'Enter' && handleSideBarKeyDown(item.name)}
					onClick={() => handleSideBarKeyDown(item.name)}
				>
					{item.component}
				</div>
			))}
		</div>
	);
};

export default Sidebar;
